import React, { useEffect } from "react";
import Loading from "Screens/components/Loading";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoginBox from "./components/LoginBox";

export default function Auth() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLogin } = useSelector((state) => ({
    isLogin: state.user.isLogin,
  }));

  useEffect(() => {
    dispatch(HandleLoading(false));
    if (isLogin) {
      navigate("/manager");
    }
  }, [isLogin]);

  return (
    <div className="auth-container">
      <Loading />
      <div className="auth-image-back" />
      <div className="auth-color-back" />
      <LoginBox />
    </div>
  );
}
